import { Paper } from "@mui/material";
import { parseISO } from "date-fns";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  clearNuevaObra,
  getPreguntasActividad,
  getPreguntasTipoDeObra,
  getTiposAvisoObra,
  getUltimoFormularioCargado,
  postActividadForm,
  postCargaNuevaObra,
  postDemolicionForm,
  postIdentificacionForm,
  postResponsablesForm,
  postTipoDeObraForm,
  postUbicacionForm
} from "../../../redux/actions/obra";
import { convertDateToNet } from "../../../util/datetime";
import Breadcrumb from "../../commons/breadcrumb/Breadcrumb";
import ConfirmDialog from "../../commons/dialog/ConfirmDialog";
import HeaderLabel from "../../commons/headerLabel/headerLabel";
import HeaderForm from "../../commons/labels/HeaderForm";
import CircularLoading from "../../commons/loading/CircularLoading";
import ResponsablesEnum from "../../enums/responsablesEnum";
import { StyledNuevaObra } from "../../styled/Obras";
import ActividadADesarrollarContainer from "./actividad/ActividadADesarrollarContainer";
import { enumTiposGestion } from "./commons/enumTipoGestion";
import NuevaObraLabel from "./commons/NuevaObraLabel";
import DemolicionContainer from "./demolicion/DemolicionContainer";
import useGestionObra from "./hooks/useGestionObra";
import IdentificacionContainer from "./identificacion/IdentificacionContainer";
import ResponsablesContainerObra from "./responsables/ResponsablesContainerObra";
import TipoDeObraContainer from "./tipoDeObra/TipoDeObraContainer";
import UbicacionContainer from "./ubicacion/UbicacionContainer";

const NuevaObraContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const postNuevaObra = useSelector((state) => state.obra.postNuevaObra);
  const [loadingPreviousForm, setLoadingPreviousForm] = useState(true);
  const [form, setForm] = useState("Identificación");
  const [fromBread, setFromBread] = useState(false);
  const [breadcrumbFields, setBreadcrumbFields] = useState([form]);

  const [getNombreTipoGestion] = useGestionObra(state?.tipoAvisoObra, state?.estado, state?.informadoSRT);

  useEffect(() => {
    if (state?.idGestionObra) {
      dispatch(getTiposAvisoObra(state.idGestionObra));
      dispatch(getUltimoFormularioCargado(state.idGestionObra)).then((d) => {
        let data = d?.value.data;
        dispatch(postIdentificacionForm({
          denominacionObra: data.denominacionObra,
          numeroObraSRT: data.numeroObraSRT,
          fechaInicioObra: data.fechaInicioObra ? parseISO(data.fechaInicioObra) : null,
          fechaFinObra: data.fechaFinObra ? parseISO(data.fechaFinObra) : null,
          idDependenciaEmpleador: data.idDependenciaEmpleador,
          resolucion: (data.resolucion3598 && "3598") || (data.resolucion5197 && "5197") || (data.resolucion31999 && "319/99"),
          idTipoContratista: data.idTipoContratista ? data.idTipoContratista : '',
          superficieAConstruir: data.superficieAConstruir.toString(),
          numeroPlantas: data.numeroPlantas,
          observaciones: data.observaciones,
          fechaRecepcion: data.fechaRecepcion ? parseISO(data.fechaRecepcion) : null,
          fechaHastaExtensionObra: data.fechaHastaExtensionObra ? parseISO(data.fechaHastaExtensionObra) : null,
          fechaSuspension: data.fechaSuspension ? parseISO(data.fechaSuspension) : null,
          fechaReinicioSuspension: data.fechaReinicioSuspension ? parseISO(data.fechaReinicioSuspension) : null,
          fechaFinReinicioSuspension: data.fechaFinReinicioSuspension ? parseISO(data.fechaFinReinicioSuspension) : null,

        }));
        dispatch(postUbicacionForm({
          idDependenciaEmpleador: data.idDependenciaEmpleador,
        }));

        dispatch(getPreguntasTipoDeObra()).then((preguntasTipoDeObraData) => {
          const preguntasTipoDeObra = preguntasTipoDeObraData?.value?.data;
          preguntasTipoDeObra.forEach((grupoPreguntas) => {
            let secuenciaPreguntas = grupoPreguntas;

            secuenciaPreguntas.itemsFormularioArt = grupoPreguntas.itemsFormularioArt.map((pregunta) => {
              let resultadoAnterior = data.resultadosAvisoObra.find((r) => r.idItemFormularioArt === pregunta.idItemFormularioArt);
              if (resultadoAnterior) {
                resultadoAnterior.resultado = resultadoAnterior.resultado.toString();
              }
              return { ...pregunta, ...resultadoAnterior };
            });
            dispatch(postTipoDeObraForm(secuenciaPreguntas));
          });
        });
        dispatch(getPreguntasActividad()).then((preguntasActividadData) => {
          const preguntasActividad = preguntasActividadData?.value?.data;
          preguntasActividad.forEach((grupoPreguntas) => {
            let secuenciaPreguntas = grupoPreguntas;
            secuenciaPreguntas.itemsFormularioArt = grupoPreguntas.itemsFormularioArt.map((pregunta) => {
              let resultadoAnterior = data.resultadosAvisoObra.find((r) => r.idItemFormularioArt === pregunta.idItemFormularioArt);
              if (resultadoAnterior) {
                resultadoAnterior.resultado = resultadoAnterior.resultado.toString();
              }
              return { ...pregunta, ...resultadoAnterior };
            });
            dispatch(postActividadForm(secuenciaPreguntas));
          });
        });


        dispatch(postDemolicionForm({
          fechaInicioDemolicion: data.fechaInicioDemolicion ? parseISO(data.fechaInicioDemolicion) : null,
          fechaFinDemolicion: data.fechaFinDemolicion ? parseISO(data.fechaFinDemolicion) : null,
          fechaInicioExcavacion: data.fechaInicioExcavacion ? parseISO(data.fechaInicioExcavacion) : null,
          fechaFinExcavacion: data.fechaFinExcavacion ? parseISO(data.fechaFinExcavacion) : null,
          fechaInicioExcavacionCA: data.fechaInicioExcavacionCA ? parseISO(data.fechaInicioExcavacionCA) : null,
          fechaFinExcavacionCA: data.fechaFinExcavacionCA ? parseISO(data.fechaFinExcavacionCA) : null,
          excavacionCAOtros: data.excavacionCAOtros,
        }));

        const responsableSeguridadHigiene = data.responsablesEmpleador.find((r) => r.codigoCargoEmpresa === ResponsablesEnum.seguridadHigiene);
        const responsableEmpleador = data.responsablesEmpleador.find((r) => r.codigoCargoEmpresa === ResponsablesEnum.representanteEmpleador);

        dispatch(postResponsablesForm({
          nombreApellidoContacto: data.nombreApellidoContacto,
          dniContacto: data.dniContacto,
          telefonoContacto: data.telefonoContacto,
          mailContacto: data.mailContacto,
          responsableSeguridadHigiene: responsableSeguridadHigiene?.idResponsableEmpleador,
          responsableEmpleador: responsableEmpleador?.idResponsableEmpleador,
        }));

      }).finally(() => setLoadingPreviousForm(false));
    } else {
      setLoadingPreviousForm(false);
    }
    return () => {
      // Clear al dejar de existir el componente
      dispatch(clearNuevaObra());
    };
  }, [state]);

  const [openCancel, setOpenCancel] = useState(false);
  const handleSubmitLastForm = (responsablesValues) => {

    const tieneAlMenosUnTipoDeObraSi = postNuevaObra.tipoDeObra
      .flat()
      .map((a) => a.itemsFormularioArt)
      .flat()
      .some((e) => e.resultado === "1");

    if (!tieneAlMenosUnTipoDeObraSi) {
      toast.error("Debe seleccionar al menos un tipo de obra como 'Sí' en el punto 5");
      return;
    }

    const tipoGestionDeObra = getNombreTipoGestion(postNuevaObra.identificacion.idTipoAvisoObra);
    let finalPayload = {
      ...postNuevaObra.identificacion,
      ...postNuevaObra.ubicacion,
      // Identificacion
      fechaFinObra: convertDateToNet(postNuevaObra.identificacion.fechaFinObra),
      fechaInicioObra: convertDateToNet(postNuevaObra.identificacion.fechaInicioObra),
      [`resolucion${postNuevaObra.identificacion.resolucion.replace(
        "/",
        ""
      )}`]: true,
      fechaHastaExtensionObra: tipoGestionDeObra === enumTiposGestion.extension
        ? postNuevaObra.identificacion.fechaHastaExtensionObra
        : null,
      fechaSuspension: (tipoGestionDeObra === enumTiposGestion.suspension || tipoGestionDeObra === enumTiposGestion.reinicio)
        ? postNuevaObra.identificacion.fechaSuspension
        : null,
      fechaReinicioSuspension: tipoGestionDeObra === enumTiposGestion.reinicio
        ? postNuevaObra.identificacion.fechaReinicioSuspension
        : null,
      fechaFinReinicioSuspension: (tipoGestionDeObra === enumTiposGestion.suspension || tipoGestionDeObra === enumTiposGestion.reinicio)
        ? postNuevaObra.identificacion.fechaFinReinicioSuspension
        : null,
      superficieAConstruir: postNuevaObra.identificacion.superficieAConstruir ? parseFloat(
        postNuevaObra.identificacion.superficieAConstruir.replace(",", ".")
      ) : null,
      // Demolicion
      ...postNuevaObra.demolicion,
      fechaInicioDemolicion: convertDateToNet(postNuevaObra.demolicion.fechaInicioDemolicion),
      fechaFinDemolicion: convertDateToNet(postNuevaObra.demolicion.fechaFinDemolicion),
      fechaInicioExcavacion: convertDateToNet(postNuevaObra.demolicion.fechaInicioExcavacion),
      fechaFinExcavacion: convertDateToNet(postNuevaObra.demolicion.fechaFinExcavacion),
      fechaInicioExcavacionCA: convertDateToNet(postNuevaObra.demolicion.fechaInicioExcavacionCA),
      fechaFinExcavacionCA: convertDateToNet(postNuevaObra.demolicion.fechaFinExcavacionCA),

      nombreApellidoContacto: responsablesValues.nombreApellidoContacto,
      dniContacto: responsablesValues.dniContacto,
      telefonoContacto: responsablesValues.telefonoContacto,
      mailContacto: responsablesValues.mailContacto,
      responsablesEmpleador: [
        {
          cuCargo: ResponsablesEnum.representanteEmpleador,
          idResponsable: responsablesValues.responsableEmpleador,
        },
        {
          cuCargo: ResponsablesEnum.seguridadHigiene,
          idResponsable: responsablesValues.responsableSeguridadHigiene,
        },
      ]
    };
    // Resolucion
    delete finalPayload.resolucion;
    delete finalPayload.numeroObraSRT

    // Resultados preguntas
    finalPayload["resultadosAvisoObra"] = [
      ...postNuevaObra.tipoDeObra
        .flat()
        .map((a) => a.itemsFormularioArt)
        .flat()
        .map((e) => ({
          idItemFormularioArt: e.idItemFormularioArt,
          seleccionOpcion: e.seleccionOpcion,
          resultado: parseInt(e.resultado),
        })),
      ...postNuevaObra.actividad.preguntas
        .flat()
        .map((a) => a.itemsFormularioArt)
        .flat()
        .map((e) => ({
          idItemFormularioArt: e.idItemFormularioArt,
          seleccionOpcion: e.seleccionOpcion,
          resultado: parseInt(e.resultado),
        })),
    ];
    // Id gestion obra para extension, suspencion o reinicio
    if (state?.idGestionObra) {
      finalPayload.idGestionObra = state.idGestionObra;
    }
    if (state?.idAvisoObra && postNuevaObra.identificacion.idTipoAvisoObra === enumTiposGestion.edicion) {
      finalPayload.idAvisoObra = state.idAvisoObra;
      delete finalPayload.idTipoAvisoObra;
      // En caso edicion no se modifica fechaRecepcion
      delete finalPayload.fechaRecepcion;
    }

    dispatch(postCargaNuevaObra(finalPayload)).then((e) => {
      toast.success(`Obra número ${e?.value?.data} enviada correctamente`);
      dispatch(clearNuevaObra());
      navigate("/obras/gestionDeObra");
    });
  };

  const handleSetForm = (form) => {
    if (!breadcrumbFields.includes(form)) {
      const auxArray = [...breadcrumbFields, form];
      setBreadcrumbFields(auxArray);
    }
    setForm(form);
  };

  const handleCancel = () => {
    setOpenCancel(true);
  }
  const handleConfirmCancel = () => {
    dispatch(clearNuevaObra());
    if (state?.idGestionObra) {
      navigate("/obras/gestionDeObra");
    }
    else {
      setBreadcrumbFields(["Identificación"]);
      handleSetForm("Identificación");
    }
    setOpenCancel(false);
  };

  const titles = {
    Identificación: "IDENTIFICACIÓN DEL AVISO DE OBRA",
    Ubicación: "UBICACIÓN",
    "Tipo de Obra": "TIPO DE OBRA",
    Actividad: "ACTIVIDADES A DESARROLLAR",
    Demolición: "DEMOLICIÓN - EXCAVACIÓN",
    Responsables: "RESPONSABLES",
    PrePresentacion: "PRE PRESENTACION",
  };

  return (
    <Paper
      style={{ overflow: "hidden", height: "fit-content", minHeight: 650 }}
    >
      <HeaderForm title={titles[form]} />
      <StyledNuevaObra.BreadcrumbContainer>
        <Breadcrumb
          setForm={setForm}
          setFields={setBreadcrumbFields}
          fields={breadcrumbFields}
          setFromBread={() => setFromBread(true)}
          form={form}
        />
      </StyledNuevaObra.BreadcrumbContainer>
      {form !== "Identificación" && (
        <StyledNuevaObra.HeaderLabel>
          <HeaderLabel>
            <NuevaObraLabel identificacion={postNuevaObra.identificacion} tipoGestionObra={getNombreTipoGestion(postNuevaObra.identificacion.idTipoAvisoObra)} />
          </HeaderLabel>

        </StyledNuevaObra.HeaderLabel>
      )}

      <div style={{ margin: 20 }}>
        {
          loadingPreviousForm ?
            <CircularLoading />
            : {
              Identificación: (
                <IdentificacionContainer
                  nextForm={handleSetForm}
                  lastFormProps={state}
                  handleCancel={handleCancel}
                />
              ),
              Ubicación: <UbicacionContainer nextForm={handleSetForm} lastFormProps={state} />,
              "Tipo de Obra": <TipoDeObraContainer nextForm={handleSetForm} />,
              Actividad: (
                <ActividadADesarrollarContainer nextForm={handleSetForm} />
              ),
              Demolición: <DemolicionContainer nextForm={handleSetForm} lastFormProps={state} />,
              Responsables: (
                <ResponsablesContainerObra
                  handleSubmitLastForm={handleSubmitLastForm}
                  handleCancel={handleCancel}
                />
              ),
            }[form]
        }
      </div>
      <ConfirmDialog
        open={openCancel}
        handleClose={() => setOpenCancel(false)}
        handleConfirm={handleConfirmCancel}
        loading={false}
        title="Cancelar"
        text="¿Está seguro de que desea cancelar? Toda la carga realizada en el formulario no se guardará"
      />
    </Paper>
  );
};

export default NuevaObraContainer;
